import Card from '@mui/material/Card';
import { Student } from 'types';
import { FormattedAssessmentOutcomes } from 'types/formatted-assessment-outcomes';
import BaseModalTitle from 'components/common/BaseModalTitle';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import StudentList from './StudentList';

const StudentScoreModal = (props: {
  outcomes: FormattedAssessmentOutcomes;
  students: Student[];
}) => {
  const [, { closeModal }] = useModal();

  return (
    <Card style={{ minWidth: '1000px' }}>
      <BaseModalTitle text={props.outcomes.label} onClose={closeModal} />
      <div style={{ display: 'flex' }}>
        <StudentList
          score={3}
          studentIds={props.outcomes.meets}
          students={props.students}
          showNumberedList={false}
        />
        <StudentList
          score={2}
          studentIds={props.outcomes.growing}
          students={props.students}
          showNumberedList={false}
        />
        <StudentList
          score={1}
          studentIds={props.outcomes.early}
          students={props.students}
          showNumberedList={false}
        />
        <StudentList
          score={0}
          studentIds={props.outcomes.notTested}
          students={props.students}
          showNumberedList={false}
        />
      </div>
    </Card>
  );
};

export default StudentScoreModal;
